import { useEffect, useState } from 'react';

// The value-shaped counterpart of debounce(): returns `value` once it has
// held still for `ms` — every change re-arms the timer and a pending update
// is cancelled on unmount, so nothing fires into an unmounted tree. The
// first render returns `value` itself.
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return debounced;
}
